<template>
  <div class="home">
    <div class="page-header">
      <h1 class="page-logo">
        <img src="~@/assets/img/home/logo_mango.png" alt="logo">
      </h1>
      <div class="page-header-right">
        <h2 class="title">芒哥-服务商业务管理平台</h2>
        <div class="header-right">
          <div class="user-info">
            <el-avatar style="vertical-align: middle;"
                       src="./avatar.png"></el-avatar>
            <span style="margin-left: 5px;vertical-align: middle;" v-if="$store.state.accountInfo">
              欢迎您，{{$store.state.accountInfo.empower_phone}}
            </span>
          </div>
          <ul class="func-list">
            <li>
              <a href="javascript:;" @click="logout">退出</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="page-main">
        <div class="breadcrumb">
          <img src="~@/assets/img/home/icon_home.svg" class="icon-home" alt="home">
          <span class="breadcrumb-item">
            <router-link to="/home" class="is-link">首页</router-link>
            <span class="separator">/</span>
          </span>
          <span class="breadcrumb-item"
                v-for="item in $store.state.meta.breadcrumb"
                :key="item.path">
            <router-link :to="item.path" class="is-link">{{item.title}}</router-link>
            <span class="separator">/</span>
          </span>
          <span class="breadcrumb-item">
            <span class="not-link">{{$store.state.meta.title}}</span>
            <span class="separator">/</span>
          </span>
        </div>
        <div class="page-container">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userLogout, empowerInfo } from '@/api/index';

export default {
  name: 'home',
  components: {},
  created() {
    console.log('created');
    empowerInfo()
      .then((res) => {
        if (res.status === 0) {
          this.$store.commit('setAccountInfo', res.data);
        }
      });
  },
  mounted() {
    console.log('mounted');
  },
  methods: {
    logout() {
      userLogout();
    },
  },
};
</script>
<style scoped lang="scss">
  .home {
    width: 100%;
    height: 100%;

    .page-header {
      position: fixed;
      top: 0;
      left: 0;
      padding-left: $page-logo-width;
      width: 100%;
      height: $page-header-height;
      background: #fff;
      z-index: 100;

      .page-logo {
        position: absolute;
        left: 0;
        top: 0;
        padding: 5px 50px 5px 25px;
        height: $page-header-height;
        line-height: $page-header-height;
        width: $page-logo-width;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }

      .page-header-right {
        position: relative;
        height: $page-header-height;
        line-height: $page-header-height;

        .title {
          padding-left: 25px;
          font-weight: 400;
          font-size: 18px;
          color: $text-color;
        }

        .header-right {
          position: absolute;
          top: 0;
          right: 0;
          padding-right: 106px;
          height: $page-header-height;

          .func-list {
            position: absolute;
            right: 14px;
            top: 0;
            width: 50px;

            li {
              a {
                padding: 0 10px;
                display: block;
                color: $color-primary;
                font-size: 14px;

                &:hover {
                  background: hsla(0, 100%, 100%, .155);
                }
              }
            }
          }

          .user-info {
            font-size: 13px;
            font-weight: 400;
          }
        }
      }
    }

    .page-body {
      padding-top: $page-header-height;
      width: 100%;
      height: 100%;

      .page-main {
        position: relative;
        padding: 48px 28px;
        width: 100%;
        height: 100%;
        background: #efefef;

        .page-container {
          padding: 16px 0;
          background: #fff;
          border-radius: 16px;
          min-height: 500px;
        }

        .breadcrumb {
          position: absolute;
          top: 20px;
          left: 38px;
          padding-left: 25px;

          .icon-home {
            position: absolute;
            left: 0;
            top: -6px;
            width: 20px;
            height: 20px;
          }

          .breadcrumb-item {
            float: left;
            font-size: 11px;
            line-height: 1;

            .is-link {
              color: $color-primary;
            }

            .separator {
              margin: 0 9px;
              font-weight: 700;
              color: $color-primary;
            }

            .not-link {
              color: #9f9fa4;
            }

            &:last-of-type {
              .separator {
                display: none;
              }
            }
          }
        }
      }
    }
  }
</style>
